export default __webpack_public_path__ + "static/alloy-03abba02411429b057053c02fa754344.gif";